import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { makePath, PATH } from 'shared';
import logo from 'images/Alphaeon_Patient_Financing_Logo.png';
function Header() {
    const history = useHistory();
    const isLanding = useRouteMatch({
        path: makePath(PATH.CREDIT_PORTAL, PATH.PAY_WITH_ALPHAEON),
        exact: true,
    });
    const handleLogoClick = () => {
        history.push(makePath(PATH.CREDIT_PORTAL, PATH.PAY_WITH_ALPHAEON));
    };
    return (_jsxs("div", { className: "pay-with-alphaeon__header", onClick: handleLogoClick, role: "button", tabIndex: 0, onKeyDown: (e) => {
            if (e.key === 'Enter')
                handleLogoClick();
            if (e.key === ' ') {
                e.preventDefault();
                handleLogoClick();
            }
        }, children: [_jsx("img", { src: logo, alt: "Alphaeon Patient Financing", className: "pay-with-alphaeon__header-logo" }), isLanding && (_jsx("div", { className: "pay-with-alphaeon__rainbow-stripe", "aria-hidden": "true" }))] }));
}
export default memo(Header);
